import { setLanguage } from "@ui5/webcomponents-base/dist/config/Language.js";
import { changeLanguage, type Language } from "@positive/i18n";
import type { i18n } from "i18next";

/**
 * Runtime language + direction switch without reload (ADR-0009/D-1): i18next texts, document `lang`/`dir`
 * and UI5's own texts (dates, ARIA, built-in labels) all follow.
 */
export async function switchLanguage(instance: i18n, language: Language): Promise<void> {
  await Promise.all([changeLanguage(instance, language), setLanguage(language)]);
}
